module.exports = __webpack_public_path__ + "static/welcome-bg_mobile-a49b6c672e8c871f6f234703b927e58d.svg";